<template>
  <div class="about">
    <Banner fromType="profile" />
    <section class="about-content">
      <div class="container">
        <div class="module-title">
          <h3>公司介绍</h3>
          <p class="small-text">Company Introduction</p>
        </div>
        <div class="about-text" v-html="aboutData?.profile">
          
        </div>
        <div class="module-title">
          <h3>发展历程</h3>
          <p class="small-text">Development History</p>
        </div>
        <div>
          <img :src="aboutData?.developImgUrl" alt="发展历程" class="history-img">
        </div>
      </div>
    </section>
    <section class="main-content">
      <Honor />
    </section>
    <section class="main-content" style="padding-top: 0">
      <Team />
    </section>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useHttpApi } from '~/composables/useApi'
import { usePageSeo } from '~/composables/useSeo'
import Banner from './compontents/banner.vue'
import Team from './compontents/team.vue'
import Honor from './compontents/honor.vue'

// 使用useHead替代usePageSeo避免middleware中的警告
usePageSeo({
  title: '公司简介-苏州瀚易特信息技术股份有限公司',
  description: '',
  keywords: '瀚易特、教育大数据企业、高新技术企业、教育专家团队 、瀚林愿',
  url: 'about'
})

interface IAboutData {
  profile: string,
  developImgUrl: string
}
const aboutData = ref<IAboutData>({
  profile: '',
  developImgUrl: ''
})
const { getCompanyProfileApi } = useHttpApi()
const getCompanyProfile = async () => {
  const res = await getCompanyProfileApi()
  aboutData.value = res?.data?.data
}

// 页面加载时获取数据
onMounted(() => {
  getCompanyProfile()
})

</script>

<style scoped lang="scss">
@use "sass:color";
@use "~~/assets/scss/main.scss" as *;

.about {
  min-height: 100vh;
}

.main-content {
  padding: 40px 0;
}

.about-content {
  // height: 842px;
  background: url('https://image-hanit.cdn.bcebos.com/sit/hly/file/20251112/1762932009514_0a5e4eae7f6344419f5f9e82c17062a4.png') no-repeat center bottom/cover;
  padding: 40px 0;
}
.about-text {
  margin-bottom: 40px;
  text-indent: 2em;
}
.history-img {
  width: 100%;
  height: 400px;
}
</style>